import { useDataValue, useDataChange } from 'Simple/Data.js'
import * as validateFns from 'Data/validate.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let questions = useDataValue({
    context: 'widget',
    path: 'questions',
    viewPath: props.viewPath,
  })

  let changeSelected = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })

  let selectedAnswers = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'answers',
  })

  return async function onChange(value, change) {
    let question = questions.find(item => item.id === value.id)
    let isValid = check(question, value.answer)

    if (isValid) {
      changeSelected(next => {
        next.flowQuestions = filterFlowQuestions(questions, {
          ...selectedAnswers,
          [question.id]: value.answer,
        })
      })
    }

    change(next => {
      next.isValid = isValid
    })
  }
}

function check(question, answer) {
  // if no specific validation defined, but it's required, if the answer is set return true
  if (
    (!question?.validation && question?.required === true && answer) ||
    question?.canSkip ||
    question?.required === false
  ) {
    return true
  }

  // validation value must match a function in validate.js
  let validate = validateFns?.[question?.validation]

  if (answer && question.validation && typeof validate === 'function') {
    return typeof answer === 'object'
      ? validate(answer[question.validation])
      : validate(answer)
  }

  return !!(question?.required && answer)
}

function filterFlowQuestions(questions, answers) {
  return questions
    .filter(item => {
      if (!Array.isArray(item.depends_on) || item.depends_on?.length === 0)
        return true

      return item.depends_on.every(dep => {
        let validate = validateFns?.[dep.validation]
        // the boolean is not within an answer object
        return validate(answers[dep.id]?.value || answers[dep.id], dep?.value)
      })
    })
    .map(item => item.id)
}
